export const FIELD_NAME = 'sharingPlansEmails';

export type EMAILS_OPTIONS = { label: string; value: string; isInvalid: boolean }[];

export const TOOLTIP_TEXT =
  'It is highly recommended the email addresses added have Manager Access in order to view the documents being uploaded.';
